export const CV_PRINT_TITLE = 'Dixon Bordiano CV - 2026'
export const CV_AUTHOR = 'Dixon Bordiano'
/** Public URL for the designed CV PDF (filename on download uses CV_PRINT_TITLE). */
export const CV_PDF_URL = '/cv/Dixon-Bordiano-CV-2026.pdf'
export const CV_PDF_DOWNLOAD_NAME = 'Dixon Bordiano CV - 2026.pdf'
/** Stable public URL for the ATS Word doc (linked as visually hidden in index.html for crawlers). */
export const CV_ATS_DOCX_URL = '/cv/Dixon-Bordiano-CV-ATS.docx'

/** Triggers a direct download of the designed CV PDF. */
export function downloadDesignedCv() {
  const link = document.createElement('a')
  link.href = CV_PDF_URL
  link.download = CV_PDF_DOWNLOAD_NAME
  link.rel = 'noopener'
  document.body.appendChild(link)
  link.click()
  link.remove()
}
